<template>
    <div class="main_wrap">
        <div class="blockHead mt_10">
            <p class="blockTitle">
                <span class="back" @click="goBackToList"><i class="iconfont icon-fanhui mr_5"></i>返回{{showTxt}}列表</span>
                <span class="split">|</span>
                <span class="name">{{frontTitle}}</span>
            </p>
        </div>
        <div class="blockBox top_border_blue bc_white shadow mt_10">
            <h1 class="fs_18 c_333">{{title}}</h1>
            <ul class="detailTab">
                <li
                    class="tabItem"
                    :class="{'active':iTypeID==tab.value,'disabled':!tab.iClick}"
                    v-for="(tab,index) in tabMenu"
                    :key="index"
                    @click="switchType(tab.value,tab.iClick)">
                    <template v-if="tab.data&&tab.data.length>1">
                        <el-popover
                            popper-class="tenderPopover"
                            placement="bottom"
                            trigger="click"
                            transition="el-zoom-in-top"
                            v-model="visible">
                            <ul class="tender-list">
                                <li
                                class="item"
                                :class="{'active':item.BidId==BidId}"
                                v-for="(item,index) in tab.data"
                                :key="index"
                                @click="changeTender(index,item.BidId)">
                                    {{item.title}}
                                </li>
                            </ul>
                            <div slot="reference" class="tabItem-popover">
                                招标详情
                                <i class="iconfont icon-iconfont_selectDown" :class="[showTypeSelect?'icon_up_amt':'icon_down_amt']"></i>
                            </div>
                        </el-popover>
                    </template>
                    <template v-else>
                        {{tab.name}}
                    </template>
                </li>
            </ul>
        </div>
        <!-- 土地/项目详情 -->
        <div v-if="iTypeID!=3" class="blockBox blockBox_detail bc_white shadow mt_20">
            <div class="detailBlock" v-for="(block,index) in landDetailData" :key="index">
                <p class="title mb_15">{{block.title}}</p>
                <ul class="zebraBox listDetail fixedLabel">
                    <li class="item" v-for="(item,idx) in block.data" :key="idx">
                        <span class="label">{{item.label}}：</span>
                        <span class="value" :title="item.value">{{item.value}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 招标详情 -->
        <template v-else>
            <div class="tender_detail_main mt_20" v-for="(item,index) in tenderDetailData" :key="index" v-show="item.BidId==BidId">
                <div class="detail_wrap bc_white shadow">
                    <div class="detail_content">
                        <div class="detailBlock" v-if="item.baseInfo">
                            <p class="title mb_15">招标基本信息</p>
                            <ul class="zebraBox listDetail fixedLabel">
                                <li
                                    class="item full"
                                    v-for="(item,index) in item.baseInfo"
                                    :key="index">
                                    <span class="label">{{item.label}}：</span>
                                    <span class="value" :title="item.value">{{item.value}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="detailBlock" v-if="item.require">
                            <p class="title mb_15">招标范围及要求</p>
                            <div class="tender_artical">
                                <!-- 公司审核状态 0.未通过 1.待审核 2.审核通过 -->
                                <div class="pass" v-if="item.require.iCheck==2"></div>
                                <div class="head">
                                    <p class="artical_title">{{item.require.BidTitle}}</p>
                                    <p class="artical_sub_title">{{item.require.BidStartTime}}</p>
                                </div>
                                <div class="main" v-html="item.require.content"></div>
                            </div>
                        </div>
                    </div>
                    <div class="signupBox flex_center">
                        <button
                        class="sign_btn"
                        :class="[item.iHaveStop?'bg_gradient_gray':'bg_gradient_blue']"
                        @click="onSign(item)">
                            {{item.iHaveStop?'报名已截止':'我要报名'}}
                        </button>
                    </div>
                </div>
                <div class="contact_wrap">
                    <div class="bc_white shadow">
                        <div class="detailBlock">
                            <p class="title mb_15">招采联系</p>
                            <ul class="zebraBox listDetail fixedLabel" v-if="userType==2">
                                <li
                                    class="item full"
                                    v-for="(item,index) in item.contact"
                                    :key="index">
                                    <span class="label">{{item.label}}：</span>
                                    <a class="value c_link" :href="item.value" :target="isScreen?'_self':'_blank'" v-if="item.value&&item.iJump">{{item.value}}</a>
                                    <span v-else class="value" :title="item.value">{{item.value}}</span>
                                </li>
                            </ul>
                            <div class="noPermission" v-else>
                                <p class="tiptitle">您不是VIP会员，无查看权限</p>
                                <p class="subtitle">购买咨询：010-68220661</p>
                                <a :target="isScreen?'_self':'_blank'" href="http://youcaiyun.com/VIPMemberPay" class="btn bg_gradient_blue">立即购买</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import ajaxService from '@/server/api.js'
import permission from "@/mixins/permission.js";
export default {
    mixins:[permission],
    data(){
        return {
            //iClick  iLandClick（土地），iHomeClick（项目），iCallBidClick（招标）
            //1：能点 0：不能点
            tabMenu:[
                {name: '土地详情',value:1,iClick:0},
                {name: '项目详情',value:2,iClick:0},
                {name: '招标详情',value:3,iClick:0,data:[]}
            ],
            pageModule:'',//页面模块类型 1 房企拿地 2 房企项目开发 3全装修市场监控 4招标采购
            iTypeID:1,//跳转详情类型 1 土地详情 2 项目详情 3 招标详情
            SolutionID:null,//项目/土地详情请求时 参数SolutionID对应数据
            iHomeID:null,//招标详情时请求时 参数SolutionID对应数据
            BidId:null,//请求招标详情时需要
            frontTitle:'',
            title:'',
            landDetailData:{},//地块||项目详情
            tenderDetailData:[],//招标详情
            // {
            //     require:{
            //         BidStartTime: '',
            //         BidTitle: '',
            //         content: '',
            //         iCheck: '0'
            //     }
            // },
            visible:false,
            activeTender:0,
            backPath:'',
        }
    },
    computed: {
        showTxt(){
            let txt = ''
            if(this.pageModule==1){
                txt='房企最新拿地'
                this.backPath = 'land'
            }else if(this.pageModule==2){
                txt='房企项目最新开工'
                this.backPath = 'project'
            }else if(this.pageModule==3){
                txt='全装修项目最新开工'
                this.backPath = 'market'
            }else if(this.pageModule==4){
                txt='招标采购'
                this.backPath = 'tender'
            }
            return txt;
        },
        showTypeSelect(){
            return this.visible
        }
    },
    mounted() {
        this.initRouter()
        this.getData()
    },
    methods: {
        initRouter(){
            if(this.$route.query.module){
                this.pageModule=this.$route.query.module
            }
            if(this.$route.query.type){
                this.iTypeID=this.$route.query.type
            }
            if(this.$route.query.id){
                if(this.$route.query.type&&this.$route.query.type==3){
                    this.iHomeID=this.$route.query.id
                }else{
                    this.SolutionID=this.$route.query.id
                }
            }
            if(this.$route.query.bId){
                this.BidId=this.$route.query.bId
            }
        },
        getData(){
            let param = {
                iTypeID:this.iTypeID
            }
            if(this.iTypeID==3){
                param.iHomeID=this.iHomeID
                if(this.BidId){
                    param.BidId=this.BidId
                }
            }else{
                param.SolutionID=this.SolutionID
            }
            ajaxService.getDetail(param).then(res=>{
                console.log('详情',res)
                if(!res.ErrorCode){
                    // tab 是否可点
                    this.tabMenu[0].iClick=res.Data.iLandClick
                    this.tabMenu[1].iClick=res.Data.iHomeClick
                    this.tabMenu[2].iClick=res.Data.iCallBidClick
                    // iHomeID
                    this.iHomeID=res.Data.iHomeID
                    // SolutionID
                    this.SolutionID=res.Data.SolutionID
                    
                    if(this.iTypeID==3){
                        this.tenderDetailData=this.tabMenu[2].data=res.Data.detail
                        if(this.tenderDetailData&&this.tenderDetailData.length){
                            if(this.BidId){
                                this.tenderDetailData.forEach(item=>{
                                    if(item.BidId==this.BidId){
                                        this.frontTitle=item.frontTitle
                                        this.title=item.title
                                    }
                                })
                            }else{
                                this.frontTitle=this.tenderDetailData[0].frontTitle
                                this.title=this.tenderDetailData[0].title
                                this.BidId=this.tenderDetailData[0].BidId
                            }
                        }
                        
                    }else{
                        this.frontTitle=res.Data.frontTitle
                        this.title=res.Data.title
                        this.landDetailData=res.Data.detail
                    }

                    document.title=this.frontTitle+" - 优采大数据"

                    this.changeRouter(this.iTypeID)
                }
            })
        },
        // 切换tab
        switchType(type,iClick){
            if(!iClick){
                return;
            }
            if(type==this.iTypeID){
                return;
            }
            this.iTypeID=type
            this.getData()
        },
        // 切换路由
        changeRouter(type){
            let _query = {
                module:this.pageModule,  
                type:type,  
                id:type==3?this.iHomeID:this.SolutionID,  
            }
            if(type==3){
                _query.bId=this.BidId
            }
            this.$router.push({
                path: '/page/detail',
                query:_query
            })
        },
        // 切换招标详情
        changeTender(index,id){
            this.activeTender=index
            this.visible=false
            this.frontTitle=this.tenderDetailData[index].frontTitle
            this.title=this.tenderDetailData[index].title
            this.BidId=id
        },
        // 报名
        onSign(item){
            console.log(item)
            // 报名已截止
            if(item.iHaveStop){ return;}

            // 企业行业和招标行业不对应，提示不能报名
            if(!item.isSameIndustry){
                this.$message({
                    message: '企业行业和招标行业不对应,不能报名.',
                    type: 'warning'
                });
                return
            }

            let url = item.DeveloperUrl?item.DeveloperUrl:('http://youcaiyun.com/Pages/Provider/Admin/InviteBidPurchaseBid.aspx?BidId='+item.BidId)
            window.open(url, this.isScreen?'_self':'_blank');

        },
        // 返回列表
        goBackToList(){
            this.$router.push({
                path: '/page/' + this.backPath,
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.tender_detail_main{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .detail_wrap{
        width: 8.08rem;
        max-height: 68vh;
        position: relative;

        .detail_content{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 0 .2rem;
            overflow-x: hidden;
            overflow-y: auto;
        }

        .fixedLabel{
            .label{
                width: 1.2rem;
            }
            .value{
                width: calc(100% - 1.2rem);
            }
        }
        &.full{
            width: 100%;
        }

        // 报名
        .signupBox{
            position: absolute;
            left: 0;
            bottom:0;
            width: 100%;
            height: 5.6vh;
            background: rgba($color: #010101, $alpha: 0.4);
            .sign_btn{
                width: 10.4vw;
                height: 3.7vh;
                line-height: 3.7vh;
                border-radius: .04rem;
                color: white;
                text-align: center;
                font-size: .16rem;
            }
        }
    }
    .contact_wrap{
        width: 3.8rem;
        .detailBlock{
            padding: .2rem;

            .noPermission{
                height: 154px;
                background: #F0F3F8;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .tiptitle{
                    color: #354052;
                    font-size: 16px;
                    margin-bottom: 15px;
                    font-weight: bold;
                }
                .subtitle{
                    color: #555555;
                    font-size: 13px;
                    margin-bottom: 15px;
                }
                .btn{
                    width:125px;
                    height: 36px;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 14px;
                }
            }
        }
        .fixedLabel{
            .label{
                width: .7rem;
                // padding-left: .2rem;
                // text-align: justify;
                // text-align-last: justify;
            }
            .value{
                width: calc(100% - .7rem);
            }
        }
    }

    .tender_artical{
        width: 100%;
        position: relative;
        box-sizing: border-box;
        padding: 0 .5rem;
        .pass{
            width: .96rem;
            height: .76rem;
            background: url('../../assets/imgs/pass.png') 0 0 no-repeat;
            background-size: cover;
            position: absolute;
            right: .5rem;
            top: .3rem;
        }
        .head{
            padding: .4rem 0 .2rem 0;
            border-bottom: .01rem solid #E6EAEE;
            text-align: center;
            .artical_title{
                color:#333;
                font-size: .16rem;
                line-height: 3;
            }
            .artical_sub_title{
                color:#999;
                font-size: .14rem;
            }
        }
        .main{
            padding: .25rem;
            line-height: 2;
        }
    }

}

.tender-list{
    padding: .05rem 0;
    .item{
        height: .36rem;
        line-height: .36rem;
        padding: 0 .13rem;
        font-size: .14rem;
        color: rgba($color: #333, $alpha: 0.8);
        cursor: pointer;
        white-space: nowrap;
        &.active,&:hover{
            background: #E9F8FC;
        }
    }
}
</style>
<style lang="scss">
.tenderPopover{
    padding: 0;
}
</style>
